<main>
    <div class="d-grid gap-4">
        <div class="page-header">
            <div class="d-flex align-items-center gap-3" style="cursor: pointer;" (click)="goBack()">
                <i class="fas fa-arrow-left back-icon"></i>
                <div class="page-title">
                    Event category type
                </div>
            </div>
        </div>

        <div class="category-card">
            <div class="d-flex gap-3 align-items-center justify-content-between">
                <div class="w-100">
                    <app-input context="Normal" class="form-item" label="Select parent category"
                        placeholder="Select parent category" type="select" [control]="parentCategoryControl"
                        [options]="parentCategoryOptions" [showAddNew]="isAdminMode ? true : false"
                        [addNewText]="isAdminMode ? 'Add new category' : ''" (addNewClicked)="openAddParentCategory()"
                        [customErrorMessages]="categoryErrorMessages">
                    </app-input>
                </div>
            </div>
        </div>

        <div class="category-card pb-3" *ngIf="selectedParentCategory">
            <div class="d-flex align-items-center justify-content-between">
                <div class="section-heading">Event category type</div>
                <app-button *ngIf="isAdminMode" [label]="'Sub category'" [minWidth]="'11rem'"
                    (clicked)="openAddSubCategory()" [bgcolor]="'rgba(0, 0, 0, 0.15)'"
                    [class.disabled]="!selectedParentCategory">
                </app-button>
            </div>

            <div class="sub-category-list mt-3" *ngIf="hasSubCategoriesInSelected" cdkDropList
                (cdkDropListDropped)="onDrop($event)" [cdkDropListData]="currentSubCategories">
                <div class="sub-category-item" *ngFor="let subCategory of currentSubCategories; let i = index" cdkDrag
                    [class.edit-mode]="editingSubCategoryId === subCategory.id" [cdkDragData]="subCategory">
                    <div class="d-flex align-items-start">
                        <div class="flex-grow-1">
                            <div *ngIf="editingSubCategoryId === subCategory.id; else viewMode"
                                class="d-flex justify-content-between gap-4">
                            </div>

                            <ng-template #viewMode>
                                <div class="d-flex align-items-center justify-content-between">
                                    <div>
                                        <div class="sub-category-name m-0">{{ subCategory.question }}</div>
                                    </div>

                                    <div class="item-actions">
                                        <button *ngIf="isAdminMode" class="edit-btn"
                                            (click)="editSubCategory(subCategory)" title="Edit">
                                            <img class="action-button" src="assets/images/Buttons/edit-button.svg"
                                                alt="Edit" />
                                        </button>
                                        <button *ngIf="isAdminMode" class="delete-btn"
                                            (click)="deleteSubCategory(subCategory)" title="Delete">
                                            <img class="action-button" src="assets/images/Buttons/delete-button.svg"
                                                alt="Delete" />
                                        </button>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <div class="empty-state" *ngIf="!hasSubCategoriesInSelected">
                <i class="far fa-file-alt"></i>
                <h4>No sub categories yet</h4>
                <p>Click "Sub category" to create your first sub category.</p>
            </div>
        </div>

        <div class="category-card pb-3" *ngIf="!selectedParentCategory">
            <div class="empty-state">
                <i class="far fa-file-alt"></i>
                <h4>Select a Category</h4>
                <p>Please select a parent category to view or manage sub categories.</p>
            </div>
        </div>
    </div>
</main>